import { BaseService } from "./../base";
export class IntPrevService extends BaseService {
  static get entity() {
    return "intprev";
  }
  static get name() {
    return "intprev";
  }

  static async getAll() {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/all`, this.name);
  }
}
